import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import {
    Close,
    Home,
    Headset,
    School,
    CalendarMonth,
    Chat,
    MailOutline,
    Palette,
    Person,
    Logout,
    ChevronLeft,
    Dashboard,
    AdminPanelSettings,
    People,
    Category,
    PhotoLibrary,
    Campaign,
    Article,
    History,
    SmartToy,
    BarChart,
    Language,
    PhoneAndroid,
    Map
} from '@mui/icons-material';
import { Switch, Typography, Divider, Box } from '@mui/material';

const Sidebar = ({ isOpen, toggleMenu }) => {
    const { user, logout } = useUser();
    const [isAdminMode, setIsAdminMode] = useState(false);
    const handleLogout = (e) => {
        e.preventDefault();
        e.stopPropagation();
        logout();
        toggleMenu();
        window.location.replace('/login');
    };

    const toggleMode = (e) => {
        e.stopPropagation();
        setIsAdminMode(!isAdminMode);
    };

    return (
        <div
            className={`sidebar-wrap sidebar-overlay ${isOpen ? 'active' : ''}`}
            onClick={(e) => {
                if (e.target.classList.contains('sidebar-wrap')) {
                    toggleMenu();
                }
            }}
        >
            <div className="closemenu text-secondary" onClick={toggleMenu}>
                <Close sx={{ fontSize: 20, verticalAlign: 'middle' }} className="me-2" /> بستن منو
            </div>
            <div className="sidebar" style={{
                maxHeight: 'calc(100vh - 60px)',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div className="row">
                    <div className="col-12 profile-sidebar">
                        <Link to="/profile" className="text-decoration-none text-dark" onClick={toggleMenu}>
                            <div className="row">
                                <div className="col-auto">
                                    <figure className="avatar avatar-100 rounded-20 shadow-sm">
                                        <img src={user?.profileImage ? `${process.env.REACT_APP_FILE_BASE_URL}/uploads/profile/${user.profileImage}` : "/assets/img/user1.jpg"} alt="" />
                                    </figure>
                                </div>
                                <div className="col px-0 align-self-center">
                                    <h5 className="mb-2">{user ? `${user.firstName || ''} ${user.lastName || 'بدون نام'}` : 'دکتر عزیز'}</h5>
                                    <p className="text-muted size-12">{user?.medicalSystemNumber ? `شماره نظام: ${user.medicalSystemNumber}` : 'عضو سازمان نظام پزشکی'}</p>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                {(user?.userRole === 'admin' || user?.userRole === 'site-admin') && (
                    <div className="row mb-3 mx-2">
                        <div className="col-12 p-3 bg-light rounded-20 border">
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Box display="flex" alignItems="center">
                                    {isAdminMode ? <AdminPanelSettings color="primary" /> : <People color="action" />}
                                    <Typography variant="body2" sx={{ mr: 1, fontWeight: 'bold', color: "#0c1224" }}>
                                        {isAdminMode ? 'منوی مدیریت' : 'منوی کاربری'}
                                    </Typography>
                                </Box>
                                <Switch
                                    checked={isAdminMode}
                                    onChange={toggleMode}
                                    onClick={(e) => e.stopPropagation()}
                                    size="small"
                                />
                            </Box>
                        </div>
                    </div>
                )}

                <div className="row" style={{ flex: 1, overflowY: 'auto' }}>
                    <div className="col-12">
                        <ul className="nav nav-pills" onClick={toggleMenu} style={{
                            fontSize: '0.875rem'
                        }}>
                            {isAdminMode && user?.userRole === 'site-admin' ? (
                                <>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/pages">
                                            <div className="avatar avatar-30 icon"><CalendarMonth /></div>
                                            <div className="col">مدیریت صفحات</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/podcasts">
                                            <div className="avatar avatar-30 icon"><CalendarMonth /></div>
                                            <div className="col">مدیریت Podcast</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/deputys">
                                            <div className="avatar avatar-30 icon"><Campaign /></div>
                                            <div className="col">مدیریت معاونت ها</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/county-addresses">
                                            <div className="avatar avatar-30 icon"><Map /></div>
                                            <div className="col">آدرس مناطق شهرستان‌ها</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/contact-messages/site">
                                            <div className="avatar avatar-30 icon"><Language /></div>
                                            <div className="col">پیام‌های تماس - سایت</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                </>
                            ) : !isAdminMode ? (
                                <>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link active" to="/" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><Home fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>پیشخوان</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/welfare-categories" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><Headset fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>رفاهی - پشتیبانی</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/retraining" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><School fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>بازآموزی</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/news" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><Article fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>اخبار و اطلاعیه‌ها</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/events" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><CalendarMonth fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>مراسمات</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/board-members" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><People fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>اعضای هیئت مدیره</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/assistant" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><SmartToy fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>دستیار هوشمند</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item" style={{ minHeight: '32px' }}>
                                        <Link className="nav-link" to="/contact" style={{ padding: '6px 8px' }}>
                                            <div className="avatar avatar-30 icon" ><Chat fontSize="small" /></div>
                                            <div className="col" style={{ fontSize: '0.875rem' }}>تماس و نظرات</div>
                                            <div className="arrow"><ChevronLeft fontSize="small" /></div>
                                        </Link>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/retraining">
                                            <div className="avatar avatar-30 icon"><Dashboard /></div>
                                            <div className="col">مدیریت بازآموزی</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/welfare-categories">
                                            <div className="avatar avatar-30 icon"><Category /></div>
                                            <div className="col">مدیریت دسته‌بندی رفاهی</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/welfare-services">
                                            <div className="avatar avatar-30 icon"><Category /></div>
                                            <div className="col">مدیریت خدمات رفاهی</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/news">
                                            <div className="avatar avatar-30 icon"><Article /></div>
                                            <div className="col">مدیریت اخبار و اطلاعیه‌ها</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/events">
                                            <div className="avatar avatar-30 icon"><CalendarMonth /></div>
                                            <div className="col">مدیریت مراسمات</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/slider">
                                            <div className="avatar avatar-30 icon"><PhotoLibrary /></div>
                                            <div className="col">مدیریت اسلایدر</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/notifications">
                                            <div className="avatar avatar-30 icon"><Campaign /></div>
                                            <div className="col">مدیریت اعلان‌ها</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/users-management">
                                            <div className="avatar avatar-30 icon"><Campaign /></div>
                                            <div className="col">مدیریت کاربران</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/contact-settings">
                                            <div className="avatar avatar-30 icon"><MailOutline /></div>
                                            <div className="col">تنظیمات تماس</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/contact-messages/app">
                                            <div className="avatar avatar-30 icon"><PhoneAndroid /></div>
                                            <div className="col">پیام‌های تماس - اپلیکیشن</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/board-members">
                                            <div className="avatar avatar-30 icon"><AdminPanelSettings /></div>
                                            <div className="col">مدیریت هیئت مدیره</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/page-view-report">
                                            <div className="avatar avatar-30 icon"><BarChart /></div>
                                            <div className="col">گزارش ورود صفحات</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/dashboard/audit-logs">
                                            <div className="avatar avatar-30 icon"><History /></div>
                                            <div className="col">لاگ‌های مدیریتی</div>
                                            <div className="arrow"><ChevronLeft /></div>
                                        </Link>
                                    </li>
                                    {/* مدیریت های بعدی اینجا اضافه می شوند */}
                                </>
                            )}

                            <Divider sx={{ my: 1, width: '100%' }} />

                            <li className="nav-item">
                                <Link className="nav-link" to="/settings">
                                    <div className="avatar avatar-30 icon"><Palette /></div>
                                    <div className="col">تنظیمات</div>
                                    <div className="arrow"><ChevronLeft /></div>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/profile">
                                    <div className="avatar avatar-30 icon"><Person /></div>
                                    <div className="col">پروفایل کاربری</div>
                                    <div className="arrow"><ChevronLeft /></div>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link d-flex align-items-center" type="button" onClick={handleLogout}>
                                    <div className="avatar avatar-30 icon"><Logout /></div>
                                    <div className="col">خروج</div>
                                    <div className="arrow"><ChevronLeft /></div>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Sidebar;
